export default {
  title: 'Contact- en betaalgegevens opslaan',
  form: {
    remember_me: {
      label: 'Maak een account aan voor sneller afrekenen bij toekomstige bestellingen.',
    },
  },
};
